import {
  ISavedViewsHook,
  Tcreate,
  Tdelete,
  Tupdate,
} from 'utils/hooks/useSavedViews/useSavedViews';

import { SavedView as TSavedView } from '@project44-models/shipment-list';

export const getCopyName = (name: string) => {
  const next = name.substring(0, 39);
  if (next.match(/copy$/)) {
    return next;
  }
  return `${next} copy`;
};

export const create = (view: TSavedView, callback: Tcreate) => async () => {
  return await callback({
    name: getCopyName(view.name),
    filterCriteria: view.filterCriteria,
    displayOptions: view.displayOptions,
  });
};

export const remove =
  ({ id }: TSavedView, callback: Tdelete) =>
  async () => {
    if (id) {
      await callback(id);
    }
  };

export const update =
  (view: TSavedView, callback: Tupdate) => async (name: string) => {
    const { id, filterCriteria, displayOptions } = view;
    if (id) {
      await callback(id, {
        id,
        name,
        filterCriteria,
        displayOptions,
      });
    }
  };

type Tdefaults = {
  namespace: string;
  accentColor: string;
  listType: string;
  createView?: () => void;
  deleteView?: () => void;
};

export const mapViews = (views: ISavedViewsHook, defaults: Tdefaults) =>
  views.data.views.map((view: TSavedView) => ({
    id: view.id as string,
    name: view.name,
    createView: create(view, views.createView),
    deleteView: remove(view, views.deleteView),
    updateView: update(view, views.updateView),
    ...defaults,
  }));
